import { IndexTable, Text } from '@shopify/polaris';

const InventoryStockTable = ({ product, inventory }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];

  return (
    <IndexTable headings={headings} itemCount={2} selectable={false} lastColumnSticky={true}>
      {<QtyDepositOriginStockRow deposit={inventory.deposit} product={product} />}
      <QtyInputStockRow product={product} />
      {<QtyDiffStockRow deposit={inventory.deposit} product={product} />}
    </IndexTable>
  );
};

export default InventoryStockTable;

const QtyDepositOriginStockRow = ({ product }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          STOCK TEÓRICO
        </Text>
      </IndexTable.Cell>
      {product.inventoryStock.map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.stockQtyExpected}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {product.inventoryStock.reduce((acc, cur) => acc + cur.stockQtyExpected, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyDiffStockRow = ({ product }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          DIFERENCIA
        </Text>
      </IndexTable.Cell>
      {product.inventoryStock.map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="bold">
            {s.stockQtyFound - s.stockQtyExpected}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {product.inventoryStock.reduce((acc, cur) => acc + cur.stockQtyFound, 0) -
            product.inventoryStock.reduce((acc, cur) => acc + cur.stockQtyExpected, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyInputStockRow = ({ product }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          INVENTARIADO
        </Text>
      </IndexTable.Cell>
      {product.inventoryStock.map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.stockQtyFound}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {product.inventoryStock.reduce((acc, cur) => acc + cur.stockQtyFound, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};
